import { css } from 'styled-components';

export default css`
  color: white;
  text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
  ul {
    margin: 0 0 1rem 0;
  }
`;
